const getPowerControlsList = (state) => state.powerControlsList;

export default {
  getPowerControlsList,
};
